import { useSelector } from 'react-redux';
import { STREAM_TYPE } from 'services/CameraStream/config';
import { selectIsTransactionSubStreamEnabled } from 'store/featureFlag/featureFlagSelector';
import { isTransactionStreamTab } from 'utils/transactionSubStream';

/**
 * Stream type a transaction camera tile plays when it is not shown large: SUB for a camera the backend sent with a
 * usable SUB entry (it decides per desk from the transactionSubStreamConfigEnabled rules), while the flag is active
 * (kill switch); otherwise the camera config's own. Tiles forced to a stream type are not affected.
 */
const useTransactionBaseStreamType = ({ camConfig, tabId, forcedStreamType }) => {
    const isEnabled = useSelector(selectIsTransactionSubStreamEnabled);
    const playsSub = isEnabled && !!camConfig?.hasSubStream && isTransactionStreamTab(tabId) && !forcedStreamType;
    return playsSub ? STREAM_TYPE.SUB : camConfig?.videoData?.streamType;
};

export default useTransactionBaseStreamType;
